import { useCallback, useEffect, useState } from 'react';
import {
  getStudents,
  createStudent,
  bulkCreateStudents,
  updateStudent,
  deleteStudent,
} from '../services/studentsService';

export function useStudents() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refetch = useCallback(() => {
    setLoading(true);
    return getStudents()
      .then((data) => {
        setStudents(data);
        setError('');
      })
      .catch((err) => setError(err.message || 'Failed to load students'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const create = useCallback(
    async (studentData) => {
      await createStudent(studentData);
      await refetch();
    },
    [refetch]
  );

  const bulkCreate = useCallback(
    async (rows) => {
      await bulkCreateStudents(rows);
      await refetch();
    },
    [refetch]
  );

  const update = useCallback(
    async (id, studentData, previousData) => {
      await updateStudent(id, studentData, previousData);
      await refetch();
    },
    [refetch]
  );

  const remove = useCallback(
    async (id, record) => {
      await deleteStudent(id, record);
      await refetch();
    },
    [refetch]
  );

  return { students, loading, error, create, bulkCreate, update, remove };
}
